export default __webpack_public_path__ + "static/media/eat-da-burger-screenshot-1.9585eada.png";